import { render, staticRenderFns } from "./modalCreateTicket.vue?vue&type=template&id=45f84b00"
import script from "./modalCreateTicket.vue?vue&type=script&lang=js"
export * from "./modalCreateTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports